const doc = document.implementation.createHTMLDocument('');
const div = doc.createElement('div');

// eslint-disable-next-line no-control-regex
const WHITESPACE_REGEX =
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
const MEDIA_TAGS = ['audio', 'image', 'img', 'source', 'video'];

function shouldRemoveElement(tagName, element) {
  return (
    tagName == 'script' ||
    tagName == 'noscript' ||
    tagName == 'noembed' ||
    !(element.attributes instanceof NamedNodeMap)
  );
}

function removeElement(element) {
  try {
    element.parentNode.removeChild(element);
  } catch (e) {
    element.outerHTML = '';
  }
}

function shouldRemoveAttribute(attributeName, attributeValue, tagName) {
  // Remove insecure attribute starting "on*" (example: <img src='' onerror=alert(1)>)
  if (attributeName.indexOf('on') == 0) {
    return true;
  }
  
  // Remove insecure src/href attribute with value starting "javascript:*" (example: href="javascript:alert(1)")
  if (
    (attributeName == 'src' || attributeName == 'href') &&
    attributeValue.indexOf('javascript:') == 0
  ) {
    return true;
  }
  
  // For non-specific tags remove insecure src/data attribute with value starting "data:*"
  return (
    MEDIA_TAGS.indexOf(tagName) == -1 &&
    (attributeName == 'src' || attributeName == 'data') &&
    attributeValue.indexOf('data:') == 0
  );
}

function sanitizeAttributes(element, tagName) {
  const attributes = element.attributes;
  for (let j = attributes.length - 1; j >= 0; j--) {
    const attribute = attributes[j];
    const attributeName = attribute.localName;
    const attributeValue = attribute.value
      .replace(WHITESPACE_REGEX, '')
      .toLowerCase()
      .trim();
    
    if (shouldRemoveAttribute(attributeName, attributeValue, tagName)) {
      element.removeAttribute(attributeName);
    }
  }
}

function safeHTML(htmlString) {
  div.innerHTML = htmlString;
  const elements = div.querySelectorAll('*');
  
  for (let i = elements.length - 1; i >= 0; i--) {
    const element = elements[i];
    const tagName = element.localName;
 
    if (shouldRemoveElement(tagName, element)) {
      removeElement(element);
      continue;
    }
 
    if (element.hasAttributes()) {
      sanitizeAttributes(element, tagName);
    }
  }
  
  return div.innerHTML;
}
export const htmlsafe = {
  name: 'htmlsafe',
  inserted: function (el, binding) {
    el.innerHTML = safeHTML(binding.value);
  },
  update: function (el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = safeHTML(binding.value);
    }
  },
};
 